export default {
    loadByLawParts: (state, payload) => {
        state.serviceUnavailable = false;
        state.dataAvailable = true;
        state.documents = payload;
    },
    loadByLawContentForPart: (state, payload) => {
        let partcontent = payload;
        state.documents.parts.forEach(part => {
            if(part.id === partcontent.id){
                part.children = partcontent.children;
            }
        });
        
    },
    byLawFetchFailed: (state, reset) => {
        state.serviceUnavailable = true;
        state.dataAvailable  = false;
        state.documents = reset;
    },
    byLawContentFetchFailed: (state, reset) => {
        state.dataAvailable  = false;
        state.documents = reset;
    },
    documentFound: (state, payload) => {
        state.serviceUnavailable = false;
        state.dataAvailable  = true;
        state.currentDocument = payload;
    },
    documentNotFound: (state, reset) => {
        state.serviceUnavailable = true;
        state.dataAvailable  = false;
        state.currentDocument = reset;
    },
    setShareQueryError: (state, reset) => {
        state.requestSuccess  = false;
        state.sharePath = reset;
    },
    setSharePath: (state, payload) => {
        state.requestSuccess  = true;
        state.sharePath = payload;
    },
    definitionFetched: (state, payload) => {
        if(payload.length == 0){
            state.definitionAvailable  = false;
        } else {
            state.definitionAvailable  = true;
            state.definitions = payload;
        }        
        
    },
    DefinitionsNotFound: (state) => {
        state.definitionAvailable  = false;
    },
    NetworkError: (state) => {
        state.serverStatus  = false;
    }
};